<template>
  <div class="paddbox autobox global-template-page">
    <el-card>
      <el-form :inline="true" :model="searchForm" @submit.prevent="search">
        <el-form-item label="模板名称">
          <el-input v-model="searchForm.templateName" placeholder="请输入模板名称模糊查询" clearable size="small"
            class="filter-control template-name-input" @keyup.enter="search" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable size="small"
            class="filter-control status-select">
            <el-option label="启用" :value="1" />
            <el-option label="停用" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" :loading="loading" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>

      <div class="table-toolbar">
        <el-button type="primary" size="small" @click="openAddDialog">新建模板</el-button>
      </div>

      <el-table v-loading="loading" :data="tableData" border stripe style="width: 100%">
        <el-table-column prop="id" label="id" min-width="40" />
        <el-table-column prop="templateName" label="模板名称" min-width="120" show-overflow-tooltip />
        <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip>
          <template #default="{ row }">{{ row.remark || '-' }}</template>
        </el-table-column>
        <el-table-column label="模板项目" min-width="160">
          <template #default="{ row }">
            <el-tooltip v-if="row.projectName" :content="`${row.projectName}（${row.projectId || '-'}）`" placement="top">
              <div class="cell-ellipsis">{{ row.projectName }}</div>
            </el-tooltip>
            <span v-else>{{ row.projectId || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="ROI / 预算" width="110">
          <template #default="{ row }">{{ row.uniRoiGoal ?? '-' }} / {{ row.budget ?? '-' }}</template>
        </el-table-column>
        <el-table-column prop="materialSelectCount" label="素材条数" width="80">
          <template #default="{ row }">{{ row.materialSelectCount ?? '-' }}</template>
        </el-table-column>
        <el-table-column label="面板 / 解锁集数" min-width="150" show-overflow-tooltip>
          <template #default="{ row }">
            {{ (row.payLevels || []).join('、') || '-' }} / {{ (row.unlockEpisodes || []).join('、') || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template #default="{ row }">
            <el-tag :type="Number(row.status) === 1 ? 'success' : 'info'" size="small">
              {{ Number(row.status) === 1 ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="155" show-overflow-tooltip />
        <el-table-column label="操作" width="150" fixed="right">
          <template #default="{ row }">
            <el-button type="primary" link size="small" @click="toggleTemplateStatus(row)">
              {{ Number(row.status) === 1 ? '停用' : '启用' }}
            </el-button>
            <el-button type="primary" link size="small" @click="editTemplate(row)">编辑</el-button>
          </template>
        </el-table-column>
        <template #empty>暂无数据</template>
      </el-table>

      <div class="pagination">
        <paginationMax100 @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :total="total"
          :pagesize="pagesize" :currentPage="currentPage" />
      </div>
    </el-card>

    <el-dialog v-model="addDialogVisible" :title="dialogTitle" width="900px" :close-on-click-modal="false"
      destroy-on-close>
      <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="140px" class="template-form">
        <div class="form-section-title">基础信息</div>
        <el-form-item label="模板名称" prop="templateName">
          <el-input v-model="addForm.templateName" placeholder="请输入模板名称" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="addForm.remark" placeholder="可选，方便辨识用途" />
        </el-form-item>

        <div class="form-section-title">分销商</div>
        <!-- <el-form-item label="分销商配置">
          <el-select v-model="addForm.distributorMode" placeholder="请选择分销商配置">
            <el-option label="单分销商" value="SINGLE" />
            <el-option label="多分销商" value="MULTI" />
          </el-select>
        </el-form-item> -->
        <el-form-item label="IAA分销商">
          <el-select v-model="addForm.iaaDistributorId" placeholder="请选择IAA分销商" clearable>
            <el-option v-for="item in iaaOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="IAP分销商">
          <el-select v-model="addForm.iapDistributorId" placeholder="请选择IAP分销商" clearable>
            <el-option v-for="item in iapOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>

        <div class="form-section-title">模板广告</div>
        <el-form-item label="模板投放账户ID">
          <el-input v-model="addForm.accountId" placeholder="请输入账户 advertiser_id" />
        </el-form-item>
        <!-- <el-form-item label="投放账户名称">
          <el-input v-model="addForm.accountName" placeholder="账户名称快照" />
        </el-form-item> -->
        <el-form-item label="本地模板项目">
          <div class="project-select-box" @click="openProjectSelector">
            <el-tooltip v-if="projectDisplayText" :content="projectDisplayText" placement="top" :show-after="300">
              <span class="project-select-text">{{ projectDisplayText }}</span>
            </el-tooltip>
            <span v-else class="project-placeholder">请选择模板项目</span>
            <el-icon class="project-arrow">
              <ArrowDown />
            </el-icon>
          </div>
        </el-form-item>
        <!-- <el-form-item label="模板项目名称">
          <el-input v-model="addForm.projectName" placeholder="请输入项目名称" />
        </el-form-item> -->
        <!-- <el-form-item label="巨量项目信息">
          <el-input v-model="addForm.projectJuliangJson" type="textarea" :rows="3" placeholder="请输入项目返回的JSON信息" />
        </el-form-item> -->

        <!-- <el-form-item label="项目名称模板">
          <el-input v-model="addForm.namePattern" placeholder="如：+剧目名称-+日期" />
        </el-form-item> -->
        <el-form-item label="全域ROI目标">
          <el-input-number v-model="addForm.uniRoiGoal" :min="0.0001" :max="5" :precision="4" :step="0.1" />
        </el-form-item>
        <el-form-item label="项目预算（元）">
          <el-input-number v-model="addForm.budget" :min="0" :precision="2" :step="100" />
        </el-form-item>
        <!-- <el-form-item label="内广项目">
          <el-radio-group v-model="addForm.innerAdProject">
            <el-radio :label="0">不开启</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="开启最后检测">
          <el-radio-group v-model="addForm.finalCheckEnabled">
            <el-radio :label="0">不开启</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="素材选取条数">
          <el-input-number v-model="addForm.materialSelectCount" :min="0" :precision="0" />
        </el-form-item>

        <div class="form-section-title">商品</div>
        <el-form-item label="商品来源组织">
          <div class="org-select-box" @click="setSpTypeFun">
            <el-tooltip v-if="addForm.orgAccountName" :content="addForm.orgAccountName" placement="top"
              :show-after="300">
              <span class="org-select-text">{{ addForm.orgAccountName }}</span>
            </el-tooltip>
            <span v-else class="org-placeholder">请选择组织账户</span>
            <el-icon class="org-arrow">
              <ArrowDown />
            </el-icon>
          </div>
        </el-form-item>
        <el-form-item label="商品库">
          <div class="product-library-row">
            <el-select v-model="addForm.productLibraryId" filterable placeholder="请先选组织，再选商品库"
              :disabled="!addForm.productAccountId" clearable>
              <el-option v-for="item in productLibraryOptions" :key="item.platformId" :label="item.name"
                :value="item.platformId" />
            </el-select>
            <el-button v-show="addForm.productAccountId" type="text" size="small"
              @click="librarylistFun">刷新商品库</el-button>
          </div>
        </el-form-item>
        <el-form-item label="版权方主体名称">
          <el-input v-model="addForm.copyrightOwner" placeholder="请输入版权方主体名称" />
        </el-form-item>
        <!-- <el-form-item label="抖音号来源账户ID">
          <el-input v-model="addForm.douyinSourceAccountId" placeholder="默认为模板投放账户ID" />
        </el-form-item>
        <el-form-item label="抖音号ID">
          <el-input v-model="addForm.douyinIdsText" placeholder="多个ID用逗号分隔" />
        </el-form-item> -->

        <div class="form-section-title">付费面板</div>
        <el-form-item label="付费面板模式">
          <el-radio-group v-model="addForm.payLevelMode">
            <el-radio label="SPECIFIED">指定面板</el-radio>
            <el-radio label="AUTO">自动匹配</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="付费面板档位">
          <el-checkbox-group v-model="addForm.payLevels">
            <el-checkbox-button v-for="opt in payPanelOptions" :key="opt" :label="opt">{{ opt
              }}</el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="解锁集数">
          <el-select v-model="addForm.unlockEpisode" placeholder="请选择解锁集数" clearable>
            <el-option v-for="item in unlockEpisodeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="small" @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="addSubmitting" @click="submitAddForm">确定</el-button>
      </template>
    </el-dialog>

    <el-dialog v-model="projectDialogVisible" title="选择模板项目" width="1100px" append-to-body destroy-on-close>
      <el-form :inline="true" :model="projectSearchForm" class="project-search-form" @submit.prevent="searchProjects">
        <el-form-item label="项目名称">
          <el-input v-model="projectSearchForm.projectName" placeholder="请输入项目名称模糊搜索" clearable size="small"
            @keyup.enter="searchProjects" />
        </el-form-item>
        <el-form-item label="项目状态">
          <el-select v-model="projectSearchForm.statusFirst" placeholder="请选择项目状态" clearable size="small">
            <el-option v-for="item in projectStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" :loading="projectLoading" @click="searchProjects">查询</el-button>
          <el-button size="small" @click="resetProjectSearch">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="projectLoading" :data="projectList" border stripe row-key="projectId" max-height="420"
        highlight-current-row style="width: 100%" @row-click="selectProject">
        <el-table-column prop="projectName" label="项目名称" min-width="220" show-overflow-tooltip />
        <el-table-column prop="projectId" label="项目ID" width="190" show-overflow-tooltip />
        <el-table-column prop="advertiserId" label="账户ID" width="170" show-overflow-tooltip />
        <el-table-column prop="budget" label="项目预算" width="120" />
        <el-table-column prop="productName" label="商品名称" min-width="180" show-overflow-tooltip />
        <template #empty>暂无项目数据</template>
      </el-table>
      <div class="pagination">
        <paginationMax100 @handleSizeChange="handleProjectSizeChange" @handleCurrentChange="handleProjectCurrentChange"
          :total="projectTotal" :pagesize="projectPagesize" :currentPage="projectCurrentPage" />
      </div>
      <template #footer>
        <el-button size="small" @click="projectDialogVisible = false">关闭</el-button>
      </template>
    </el-dialog>

    <el-dialog v-model="orgAccountView" title="选择组织账户" width="70%" append-to-body destroy-on-close>
      <ylyOrganizationTree :datas="orgTreeType" @getOrgData="getOrgData"></ylyOrganizationTree>
    </el-dialog>
  </div>
</template>

<script>
import { globalTemplatePage, globalTemplateAdd, globalTemplateUpdate, globalTemplateDetail, globalAdConfigcheckAccounts, globalTemplateProjectMaterial, teamsharecheckAccounts, projectSyncProjectPage, librarylist } from '@/request/new/ylyBatch'
import { ElMessage } from 'element-plus'
import { ArrowDown } from '@element-plus/icons-vue'
import { computed, reactive, ref, toRefs, watch } from 'vue'
import paginationMax100 from '@/components/paginationMax100.vue'
import ylyOrganizationTree from '@/components/ylyBatch/ylyOrganizationTree.vue'

export default {
  name: 'ylyGlobalTemplate',
  components: { paginationMax100, ArrowDown, ylyOrganizationTree },
  setup() {
    const state = reactive({
      searchForm: {
        templateName: '',
        status: '',
      },
      tableData: [],
      loading: false,
      pagesize: 20,
      currentPage: 1,
      total: 0,
      handleCurrentChange: (page) => {
        state.currentPage = page
        globalTemplatePageFun()
      },
      handleSizeChange: (size) => {
        state.pagesize = size
        state.currentPage = 1
        globalTemplatePageFun()
      },
    })

    const switchText = (value) => (Number(value) === 1 ? '开启' : '不开启')

    const globalTemplatePageFun = () => {
      state.loading = true
      const params = {
        templateName: state.searchForm.templateName,
        status: state.searchForm.status,
        currentPage: state.currentPage,
        size: state.pagesize,
      }
      globalTemplatePage(params).then((res) => {
        const pageData = res.data || {}
        state.currentPage = pageData.currenPage || state.currentPage
        state.total = pageData.totalSize || 0
        state.tableData = Array.isArray(pageData.data) ? pageData.data : []
      }).catch(() => {
        ElMessage.error('模板列表查询失败')
      }).finally(() => {
        state.loading = false
      })
    }

    const search = () => {
      state.currentPage = 1
      globalTemplatePageFun()
    }

    const addDialogVisible = ref(false)
    const dialogTitle = ref('新建模板')
    const editingTemplateId = ref(null)
    const addSubmitting = ref(false)
    const addFormRef = ref(null)
    const addForm = reactive({
      templateName: '',
      remark: '',
      distributorMode: 'MULTI',
      iaaDistributorId: '1855633968499848',
      iapDistributorId: '1855633968499864',
      accountId: '',
      accountName: '',
      projectId: '',
      projectName: '',
      projectJuliangJson: '',
      namePattern: '',
      uniRoiGoal: 1.2,
      budget: 300,
      innerAdProject: 0,
      finalCheckEnabled: 1,
      materialSelectCount: 20,
      productAccountId: '',
      productLibraryId: '',
      orgAccountName: '',
      copyrightOwner: '',
      douyinSourceAccountId: '',
      douyinIdsText: '',
      payLevelMode: 'SPECIFIED',
      payLevels: ['中额'],
      unlockEpisode: null,
    })
    const addFormRules = reactive({
      templateName: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
    })
    // IAA 分销商下拉
    const iaaOptions = [
      { label: '端原生免费漫剧', value: '1855633968499848' },
      { label: '端原生免费短剧', value: '1851001214864424' },
    ]
    // IAP 分销商下拉
    const iapOptions = [
      { label: '端原生付费漫剧', value: '1855633968499864' },
      { label: '端原生付费短剧', value: '1851001214864440' },
    ]
    const payPanelOptions = ['中额', '小额', '超小额', '超超小额']
    const unlockEpisodeOptions = Array.from({ length: 20 }, (_, index) => ({
      label: `第${index + 1}章`,
      value: index + 1,
    }))

    // ==========商品来源组织 / 商品库==========
    const orgAccountView = ref(false)
    const orgTreeType = ref('setSpType')
    const productLibraryOptions = ref([])

    // 打开组织树选择
    const setSpTypeFun = () => {
      orgTreeType.value = 'setSpType'
      orgAccountView.value = true
    }

    // 接收组织选择结果：回填组织ID/名称，并重新拉取商品库
    const getOrgData = (data) => {
      if (data.type === 'setSpType') {
        addForm.productAccountId = data.id
        addForm.orgAccountName = data.name
        addForm.productLibraryId = ''
        productLibraryOptions.value = []
        librarylistFun()
      }
      orgAccountView.value = false
    }

    // 查询商品库（依赖来源组织）
    const librarylistFun = () => {
      if (!addForm.productAccountId) {
        return ElMessage.error('请先选择组织')
      }
      librarylist({ accountId: addForm.productAccountId, currenPage: 1, size: 1000 }).then((res) => {
        productLibraryOptions.value = res.data?.data || []
        if (productLibraryOptions.value.length === 0) {
          ElMessage.error('商品库为空！！！请排查：检查该组织是否有商品库')
        }
      })
    }

    // ==========模板项目选择==========
    const loginUserName = localStorage.getItem('userName')
    const projectDialogVisible = ref(false)
    // 账户授权校验中（防止重复点击）
    const projectChecking = ref(false)
    const projectList = ref([])
    const projectLoading = ref(false)
    const projectPagesize = ref(20)
    const projectCurrentPage = ref(1)
    const projectTotal = ref(0)
    const projectSearchForm = reactive({ projectName: '', statusFirst: '' })
    const projectStatusOptions = [
      { label: '已删除', value: 'PROJECT_STATUS_DELETE' },
      { label: '未投放', value: 'PROJECT_STATUS_DISABLE' },
      { label: '启用中', value: 'PROJECT_STATUS_ENABLE' },
      { label: '已终止', value: 'PROJECT_STATUS_FROZEN' },
    ]

    const projectDisplayText = computed(() => {
      if (!addForm.projectId) return ''
      return addForm.projectName ? `${addForm.projectName}（${addForm.projectId}）` : String(addForm.projectId)
    })

    // 项目分页查询（只查当前投放账户下的项目）
    const projectListFun = () => {
      projectLoading.value = true
      const params = {
        currentPage: projectCurrentPage.value,
        size: projectPagesize.value,
        advertiserIds: [Number(addForm.accountId)],
      }
      if (projectSearchForm.projectName.trim()) params.projectNames = [projectSearchForm.projectName.trim()]
      if (projectSearchForm.statusFirst) params.statusFirst = projectSearchForm.statusFirst
      projectSyncProjectPage(params).then((res) => {
        if (res.code == 200) {
          const data = res.data || {}
          projectList.value = data.data || []
          projectTotal.value = data.totalSize ?? 0
          projectCurrentPage.value = data.currenPage || projectCurrentPage.value
        } else {
          projectList.value = []
          projectTotal.value = 0
        }
      }).finally(() => {
        projectLoading.value = false
      })
    }

    const searchProjects = () => {
      projectCurrentPage.value = 1
      projectListFun()
    }

    const resetProjectSearch = () => {
      projectSearchForm.projectName = ''
      projectSearchForm.statusFirst = ''
      projectCurrentPage.value = 1
      projectListFun()
    }

    const handleProjectCurrentChange = (page) => {
      projectCurrentPage.value = page
      projectListFun()
    }

    const handleProjectSizeChange = (size) => {
      projectPagesize.value = size
      projectCurrentPage.value = 1
      projectListFun()
    }

    // 校验账户通过后打开项目选择弹窗
    const openProjectDialogFun = () => {
      projectDialogVisible.value = true
      projectCurrentPage.value = 1
      projectListFun()
    }

    // 点击模板项目：先校验账户是否存在、是否已授权，通过后拉取项目列表
    const openProjectSelector = async () => {
      const accountId = String(addForm.accountId || '').trim()
      if (!accountId) {
        return ElMessage.warning('请先填写模板投放账户ID')
      }
      if (projectChecking.value) return
      projectChecking.value = true
      try {
        const res = await globalAdConfigcheckAccounts([Number(accountId)])
        if (res.code != 200) return
        // 管理员不走账户授权校验
        if (loginUserName === '黄彬' || loginUserName === '任文龙') {
          openProjectDialogFun()
          return
        }
        const authRes = await teamsharecheckAccounts({ accountIds: [Number(accountId)] })
        if (authRes.code != 200) return
        const noAuthList = (authRes.data || []).filter((item) => !item.allowed)
        if (noAuthList.length > 0) {
          const errMsg = noAuthList.map((item) => `组织名称：${item.teamName}<br/>账户名称：${item.accountName}<br/>账户id：${item.accountId}<br/>未授权请找组长授权`).join('<br/><br/>')
          return ElMessage.error({ dangerouslyUseHTMLString: true, message: errMsg })
        }
        openProjectDialogFun()
      } finally {
        projectChecking.value = false
      }
    }

    // 选中项目后查询巨量项目信息并回填
    const selectProject = async (row) => {
      if (!row) return
      addForm.projectId = row.projectId == null ? '' : String(row.projectId)
      addForm.projectName = row.projectName || ''
      projectDialogVisible.value = false
      try {
        const res = await globalTemplateProjectMaterial({
          advertiserId: Number(addForm.accountId),
          projectId: String(row.projectId),
          cursor: 0,
          count: 100,
        })
        if (res.code == 200 || res.code == 0) {
          const projectData = res.data ?? {}
          addForm.projectJuliangJson = typeof projectData === 'string'
            ? projectData
            : JSON.stringify(projectData)
        } else {
          addForm.projectJuliangJson = ''
          ElMessage.error(res.message || res.msg || '查询巨量项目信息失败')
        }
      } catch (error) {
        addForm.projectJuliangJson = ''
        ElMessage.error('查询巨量项目信息失败')
      }
    }

    // 切换投放账户后清空已选项目，避免账户与项目不匹配
    watch(
      () => addForm.accountId,
      () => {
        addForm.projectId = ''
        addForm.projectName = ''
        addForm.projectJuliangJson = ''
      }
    )

    const openAddDialog = () => {
      editingTemplateId.value = null
      dialogTitle.value = '新建模板'
      addFormRef.value?.resetFields()
      productLibraryOptions.value = []
      Object.assign(addForm, {
        templateName: '', remark: '', distributorMode: 'MULTI', iaaDistributorId: '1855633968499848', iapDistributorId: '1855633968499864',
        accountId: '', accountName: '', projectId: '', projectName: '', projectJuliangJson: '', namePattern: '',
        uniRoiGoal: 1.2, budget: 300, innerAdProject: 0, finalCheckEnabled: 1, materialSelectCount: 20,
        productAccountId: '', productLibraryId: '', orgAccountName: '', copyrightOwner: '', douyinSourceAccountId: '', douyinIdsText: '',
        payLevelMode: 'SPECIFIED', payLevels: ['中额'], unlockEpisode: null,
      })
      addDialogVisible.value = true
    }

    // 编辑模板：查询详情后回显
    const editTemplate = (row) => {
      if (!row) return
      editingTemplateId.value = row.id
      dialogTitle.value = '编辑模板'
      productLibraryOptions.value = []
      globalTemplateDetail({ id: row.id }).then((res) => {
        const data = (res.code == 200 || res.code == 0) && res.data && res.data.templateName != null ? res.data : row
        Object.assign(addForm, {
          templateName: data.templateName || '',
          remark: data.remark || '',
          distributorMode: data.distributorMode || 'MULTI',
          iaaDistributorId: data.iaaDistributorId == null ? '' : String(data.iaaDistributorId),
          iapDistributorId: data.iapDistributorId == null ? '' : String(data.iapDistributorId),
          accountId: data.accountId == null ? '' : String(data.accountId),
          accountName: data.accountName || '',
          projectId: data.projectId == null ? '' : String(data.projectId),
          projectName: data.projectName || '',
          projectJuliangJson: data.projectJuliangJson || '',
          namePattern: data.namePattern || '',
          uniRoiGoal: data.uniRoiGoal == null ? null : Number(data.uniRoiGoal),
          budget: data.budget == null ? null : Number(data.budget),
          innerAdProject: Number(data.innerAdProject) === 1 ? 1 : 0,
          finalCheckEnabled: Number(data.finalCheckEnabled) === 1 ? 1 : 0,
          materialSelectCount: data.materialSelectCount == null ? 20 : Number(data.materialSelectCount),
          productAccountId: data.productAccountId == null ? '' : String(data.productAccountId),
          productLibraryId: data.productLibraryId == null ? '' : String(data.productLibraryId),
          orgAccountName: data.orgAccountName || '',
          copyrightOwner: data.copyrightOwner || '',
          douyinSourceAccountId: data.douyinSourceAccountId == null ? '' : String(data.douyinSourceAccountId),
          douyinIdsText: Array.isArray(data.douyinIds) ? data.douyinIds.join(',') : '',
          payLevelMode: data.payLevelMode || 'SPECIFIED',
          payLevels: Array.isArray(data.payLevels) ? [...data.payLevels] : [],
          unlockEpisode: Array.isArray(data.unlockEpisodes) && data.unlockEpisodes.length ? data.unlockEpisodes[0] : null,
        })
        // 回显商品库：有组织则拉取该组织商品库
        if (addForm.productAccountId) {
          librarylistFun()
        }
        addDialogVisible.value = true
      }).catch(() => {
        ElMessage.error('查询模板详情失败')
      })
    }

    // 改变模板状态：把整行数据原样回传，仅切换 status 后调用接口
    const toggleTemplateStatus = (row) => {
      if (!row) return
      const nextStatus = Number(row.status) === 1 ? 0 : 1
      const payload = { ...row, status: nextStatus }
      globalTemplateUpdate(payload).then((res) => {
        if (res.code == 200 || res.code == 0) {
          ElMessage.success(nextStatus === 1 ? '已启用' : '已停用')
          globalTemplatePageFun()
        } else {
          ElMessage.error(res.message || res.msg || '状态更新失败')
        }
      }).catch(() => {
        ElMessage.error('状态更新失败')
      })
    }

    const submitAddForm = () => {
      if (!addFormRef.value) return
      addFormRef.value.validate((valid) => {
        if (!valid) return
        const payload = { ...addForm }
        payload.iaaDistributorId = payload.iaaDistributorId === '' ? undefined : Number(payload.iaaDistributorId)
        payload.iapDistributorId = payload.iapDistributorId === '' ? undefined : Number(payload.iapDistributorId)
        payload.accountId = payload.accountId === '' ? undefined : Number(payload.accountId)
        payload.productAccountId = payload.productAccountId === '' ? undefined : Number(payload.productAccountId)
        payload.douyinSourceAccountId = payload.douyinSourceAccountId === '' ? undefined : Number(payload.douyinSourceAccountId)
        payload.uniRoiGoal = payload.uniRoiGoal === null ? undefined : Number(payload.uniRoiGoal)
        payload.budget = payload.budget === null ? undefined : Number(payload.budget)
        payload.douyinIds = payload.douyinIdsText.split(',').map((item) => item.trim()).filter(Boolean)
        payload.payLevels = [...payload.payLevels]
        payload.unlockEpisodes = payload.unlockEpisode == null || payload.unlockEpisode === '' ? [] : [Number(payload.unlockEpisode)]
        delete payload.unlockEpisode
        delete payload.douyinIdsText
        delete payload.orgAccountName
        if (editingTemplateId.value != null) {
          payload.id = editingTemplateId.value
        }
        addSubmitting.value = true
        const isEdit = editingTemplateId.value != null
        const request = isEdit ? globalTemplateUpdate(payload) : globalTemplateAdd(payload)
        request.then((res) => {
          if (res.code != 200 && res.code != 0) {
            return ElMessage.error(res.message || res.msg || (isEdit ? '编辑模板失败' : '新建模板失败'))
          }
          ElMessage.success(isEdit ? '编辑模板成功' : '新建模板成功')
          addDialogVisible.value = false
          search()
        }).catch(() => {
          ElMessage.error(isEdit ? '编辑模板失败' : '新建模板失败')
        }).finally(() => {
          addSubmitting.value = false
        })
      })
    }

    globalTemplatePageFun()

    return {
      ...toRefs(state),
      switchText,
      search,
      addDialogVisible,
      dialogTitle,
      addSubmitting,
      addFormRef,
      addForm,
      addFormRules,
      iaaOptions,
      iapOptions,
      payPanelOptions,
      unlockEpisodeOptions,
      orgAccountView,
      orgTreeType,
      productLibraryOptions,
      setSpTypeFun,
      getOrgData,
      librarylistFun,
      projectDialogVisible,
      projectChecking,
      projectList,
      projectLoading,
      projectPagesize,
      projectCurrentPage,
      projectTotal,
      projectSearchForm,
      projectStatusOptions,
      projectDisplayText,
      searchProjects,
      resetProjectSearch,
      openProjectSelector,
      selectProject,
      handleProjectCurrentChange,
      handleProjectSizeChange,
      openAddDialog,
      editTemplate,
      toggleTemplateStatus,
      submitAddForm,
    }
  },
}
</script>

<style lang="scss" scoped>
.global-template-page {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
  box-sizing: border-box;

  :deep(.el-card),
  :deep(.el-card__body) {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }
}

.table-toolbar {
  margin-bottom: 12px;
}


.cell-sub {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
}

.cell-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tag-gap {
  margin-right: 4px;
}

.tooltip-block {
  max-width: 480px;
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 300px;
  overflow: auto;
}

.pagination {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

.filter-control {
  height: 28px;
}

.template-name-input {
  width: 220px;
}

.status-select {
  width: 140px;
}

.template-form {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 16px;
}

.form-section-title {
  margin: 18px 0 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e7ed;
  color: #303133;
  font-weight: 600;
}

.form-section-title:first-child {
  margin-top: 0;
}

.template-form :deep(.el-select),
.template-form :deep(.el-input-number) {
  width: 100%;
}

.org-select-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 13px;
  color: #303133;
  cursor: pointer;
  background: #fff;

  &:hover {
    border-color: #409eff;
  }
}

.org-select-text,
.org-placeholder {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.org-placeholder {
  color: #a8abb2;
}

.org-arrow {
  flex-shrink: 0;
  margin-left: 8px;
  color: #a8abb2;
}

.product-library-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;

  .el-select {
    flex: 1;
    min-width: 0;
  }
}

.project-search-form {
  margin-bottom: 12px;
}

.project-select-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 13px;
  color: #303133;
  cursor: pointer;
  background: #fff;
  transition: border-color 0.2s;

  &:hover {
    border-color: #c0c4cc;
  }

  .project-placeholder {
    flex: 1;
    min-width: 0;
    color: #a8abb2;
  }

  .project-select-text {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .project-arrow {
    color: #a8abb2;
  }
}
</style>
